const { getThresholds, getThresholdRelativeToMOS } = require('../../../forecast/tools/read/psm-thresholds')

function buildCalculationModalData ({
  soh,
  amc: amcInput,
  programId,
  budgetAllocatedQty
}) {
  const thresholds = getThresholds(programId)
  const { min, reOrder, max } = thresholds
  const leadTimeMonths = reOrder.months - min.months

  const amc = amcInput != null ? amcInput : 0
  const currentSoh = soh != null ? soh : 0

  // Current stock in months (raw for logic, rounded for display)
  let rawStockMonths
  if (amc > 0) {
    rawStockMonths = currentSoh / amc
  } else {
    rawStockMonths = currentSoh > 0 ? 99 : 0
  }
  const currentStockMonths = rawStockMonths === 99
    ? 99
    : parseFloat(rawStockMonths.toFixed(1))

  // Threshold for current stock box
  const threshold = getThresholdRelativeToMOS(thresholds, rawStockMonths)

  // Target stock
  const targetMonths = max.months
  const targetStockLevel = Math.round(amc * targetMonths)

  // Calculation rows
  const leadTimeConsumption = Math.round(amc * leadTimeMonths)
  const effectiveTarget = Math.round(amc * (targetMonths + leadTimeMonths))
  const suggestedQuantity = effectiveTarget - currentSoh

  // Budget coverage (optional)
  const hasBudgetData = budgetAllocatedQty != null
  let budgetCovers = null
  let budgetResultMonths = null
  if (hasBudgetData) {
    budgetCovers = budgetAllocatedQty
    if (amc > 0) {
      budgetResultMonths = parseFloat(((currentSoh + budgetAllocatedQty) / amc).toFixed(1))
    }
  }

  return {
    currentStockLevel: currentSoh,
    currentStockMonths,
    threshold,
    targetMonths,
    targetStockLevel,
    amc,
    calculation: {
      targetWithBuffer: effectiveTarget,
      currentStockOnHand: currentSoh,
      leadTimeConsumption,
      quantityNeeded: suggestedQuantity,
      budgetCovers,
      budgetResultMonths
    }
  }
}

exports.buildCalculationModalData = buildCalculationModalData
